const api = process.env.NEXT_PUBLIC_API_URL || '';

export async function postApi(data: any[]) {
  try {
    const resp = await fetch(api, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await resp.json();
    console.log(responseData);
    return responseData;
  } catch (err) {
    console.log(`Error en POST ${err}`);
  }
}

export async function putApi(idArticle: string, data: any) {
  try {
    const resp = await fetch(`${api}article/${idArticle}`, {
      method: 'PUT',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await resp.json();
    console.log(responseData);
    return responseData;
  } catch (error) {
    console.log('Put Error' + error);
  }
}

export async function patchApi(
  idArticle: string,
  categorie: string,
  index1: number,
  index2: number,
  updatedField1: any,
  updatedField2: any
) {
  try {
    const resp = await fetch(`${api}article/${idArticle}`, {
      method: 'PATCH',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        categorie,
        updates: [
          { index: index1, updatedField: updatedField1 },
          { index: index2, updatedField: updatedField2 },
        ],
      }),
    });

    const responseData = await resp.json();
    console.log(responseData);
    return responseData;
  } catch (error) {
    console.log('Error in Patch Article ', error);
  }
}

export async function deleteApi(id: string) {
  try {
    const resp = await fetch(api, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    });

    const response = await resp.json();
    console.log('DELETE RESPONSE ' + JSON.stringify(response));
    return response;
  } catch (error) {
    console.log('DELETE error :' + error);
  }
}

export const getArticles = async () => {
  try {
    const resp = await fetch(api, {
      method: 'GET',
      cache: 'no-store',
    });
    const data = await resp.json();
    return data;
  } catch (error) {
    console.log(`Error GET ARTICLES: ${error}`);
  }
};

export const FetchArticleByID = async (idBd: string) => {
  try {
    const resp = await fetch(`${api}article/${idBd}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!resp.ok) {
      throw new Error(`Failed to fetch article`);
    }
    const article = await resp.json();
    return article;
  } catch (error) {
    console.log('ERROR IN GET ONE ARTICLE: ', error);
    return null;
  }
};

export const getAuthors = async () => {
  try {
    const resp = await fetch(api, {
      method: 'GET',
      cache: 'no-store',
    });

    const data = await resp.json();

    const authors = data.filter((item: any) => item.author);
    return authors;
  } catch (error) {
    console.log(`Error GET AUTHORS: ${error}`);
  }
};

export const FetchImages = async () => {
  const images: any[] = [];
  const data = await getArticles();
  const articles = data.filter((art: any) => art.article);

  if (articles)
    articles.forEach((article: any) =>
      article.article.map((item: any) => {
        if (item.mainImage) images.push(item.mainImage);
        if (item.imageContent) images.push(item.imageContent);
      })
    );

  return images;
};

export const setContentDynamicSections = (data: any, contentType: string) => {
  const content =
    data &&
    [...data.filter((item: any) => item[contentType])].map(
      (item: any) => item[contentType] && item[contentType].map((item: any) => item)
    );

  const articlesContent = data && [...data.filter((item: any) => item.article)];
  const booksContent = data && [...data.filter((item: any) => item.book)];
  const coursesContent = data && [...data.filter((item: any) => item.course)];
  switch (contentType) {
    case 'article':
      const articles = [
        ...articlesContent.map((art: any) => {
          return {
            id: art._id,
            mainTitle: art.article[0].mainTitle,
            cardImage: art.article[1].cardImage,
            published: art.article[2].published,
            publishedDate: art.article[3].publishedDate,
            slug: art.article[art.article.length - 1].slug,
          };
        }),
      ];

      return articles;
    case 'course':
      const courses = [
        ...coursesContent.map((course: any) => {
          return {
            id: course._id,
            mainTitle: course.course[0].mainTitle,
            cardImage: course.course[1].cardImage,
            activitieDate: course.course[3].activitieDate,
          };
        }),
      ];
      return courses;
    case 'activitie':
      const activities = [
        ...content.map((act: any) => {
          return {
            mainTitle: act[0].mainTitle,
            cardImage: act[1].cardImage,
            activitieDate: act[3].activitieDate,
          };
        }),
      ];
      return activities;
    case 'book':
      const books = [
        ...booksContent.map((book: any) => {
          return {
            id: book._id,
            mainTitle: book.book[0].mainTitle,
            cardImage: book.book[1].cardImage,
            published: book.book[2].published,
            publishedDate: book.book[3].publishedDate,
            authors: book.book[4].authors,
            description: book.book[5].textContent,
            slug: book.book[book.book.length - 1].slug,
          };
        }),
      ];
      return books;
    case 'author':
      const authors = [
        ...content.map((author: any) => {
          return {
            mainTitle: author[0].mainTitle,
            cardImage: author[1].cardImage,
            published: author[2].published,
            publishedDate: author[3].publishedDate,
            description: author[4].textContent,
            slug: author[author.length - 1].slug,
          };
        }),
      ];
      return authors;

    default:
      break;
  }
};

export const getSubscribers = async () => {
  try {
    const resp = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/subscribers`, {
      method: 'GET',
      cache: 'no-store',
    });
    const data = await resp.json();

    return data;
  } catch (error) {
    console.log(`Error GET Subscribers: ${error}`);
  }
};

export async function postSubscriber(data: any[]) {
  try {
    const resp = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/subscribers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await resp.json();
    console.log(responseData);
    return responseData;
  } catch (err) {
    console.log(`Error in post subscriber ${err}`);
  }
}

export async function deleteSubscriber(id: string) {
  try {
    const resp = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/subscribers`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id }),
    });

    const response = await resp.json();
    console.log('DELETE SUBSCRIBER RESPONSE ' + JSON.stringify(response));
    return response;
  } catch (error) {
    console.log('DELETE SUBSCRIBER error :' + error);
  }
}

export async function putSubscriber(idSubscriber: string | undefined, data: any) {
  try {
    const resp = await fetch(`${api}subscribers/${idSubscriber}`, {
      method: 'PUT',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const responseData = await resp.json();
    console.log(responseData);
    return responseData;
  } catch (error) {
    console.log('Error in put Subscriber: ' + error);
  }
}
